var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsEnum, IsDate, IsString, IsOptional, IsNumber, IsBoolean, ValidateNested, IsObject } from "class-validator";
import { NotificationAttachment, PatientLanguageSwitchUrls } from "./notification.dtos";
import { ContactMethod } from "./consentconfig.dtos";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
import { ApiProperty, ApiPropertyOptional, OmitType } from "@nestjs/swagger";
export class PatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDto.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDto.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Number)
], PatientDto.prototype, "age", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDto.prototype, "dateOfBirth", void 0);
export class PatientGuidedConsentDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "healthExPatientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientGuidedConsentDto.prototype, "birthDate", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientGuidedConsentDto.prototype, "lastAccessed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "language", void 0);
export class PatientGuidedConsentUpdate {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "userId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "healthExPatientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientGuidedConsentUpdate.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "language", void 0);
export class PatientGuidedConsentsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => PatientGuidedConsentDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientGuidedConsentsDto.prototype, "patients", void 0);
export var PatientRequestReminderSendType;
(function (PatientRequestReminderSendType) {
    PatientRequestReminderSendType["INITIAL"] = "INITIAL";
    PatientRequestReminderSendType["AUTOMATED_REMINDER"] = "AUTOMATED_REMINDER";
    PatientRequestReminderSendType["MANUAL_REMINDER"] = "MANUAL_REMINDER";
})(PatientRequestReminderSendType || (PatientRequestReminderSendType = {}));
export class GlobalPatientReference {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "mrn", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GlobalPatientReference.prototype, "noDataAccess", void 0);
__decorate([
    IsEnum(PatientRequestReminderSendType),
    IsOptional(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "patientRequestReminderSendType", void 0);
export class PatientSearchDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientSearchDto.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "phone", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], PatientSearchDto.prototype, "age", void 0);
export var PatientConsentNotificationType;
(function (PatientConsentNotificationType) {
    PatientConsentNotificationType["REVOKE_PRESCREEN"] = "REVOKE_PRESCREEN";
    PatientConsentNotificationType["REVOKE_ENROLLMENT"] = "REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["AI_DATA_USE_REVOKE_ENROLLMENT"] = "AI_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REVOKE_ENROLLMENT"] = "PDDE_RESEARCH_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["DECLINE_PRESCREEN"] = "DECLINE_PRESCREEN";
    PatientConsentNotificationType["DECLINE_ENROLLMENT"] = "DECLINE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_DECLINE_ENROLLMENT"] = "PDDE_DECLINE_ENROLLMENT";
    PatientConsentNotificationType["AI_DATA_USE_DECLINE_ENROLLMENT"] = "AI_DATA_USE_DECLINE_ENROLLMENT";
    PatientConsentNotificationType["PRESCREEN_CONFIRMATION"] = "PRESCREEN_CONFIRMATION";
    PatientConsentNotificationType["ENROLLMENT_CONFIRMATION"] = "ENROLLMENT_CONFIRMATION";
    PatientConsentNotificationType["REQUEST_PRESCREEN"] = "REQUEST_PRESCREEN";
    PatientConsentNotificationType["REMINDER_PRESCREEN"] = "REMINDER_PRESCREEN";
    PatientConsentNotificationType["DEIDENTIFIED"] = "DEIDENTIFIED";
    PatientConsentNotificationType["REQUEST_ENROLLMENT"] = "REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REQUEST_ENROLLMENT"] = "PDDE_RESEARCH_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["REMINDER_ENROLLMENT"] = "REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REMINDER_ENROLLMENT"] = "PDDE_RESEARCH_REMINDER_ENROLLMENT";
})(PatientConsentNotificationType || (PatientConsentNotificationType = {}));
export const externalResearcherSupportedPatientConsentNotificationTypes = new Set([
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_DECLINE_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT,
]);
export function updateConsentNotificationTypeIfNeeded(notificationType, isPdda, isGeneralDataUse, isAiDataUse) {
    if (!isPdda)
        return notificationType;
    if (notificationType === PatientConsentNotificationType.REQUEST_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REMINDER_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.DECLINE_ENROLLMENT) {
        return isAiDataUse
            ? PatientConsentNotificationType.AI_DATA_USE_DECLINE_ENROLLMENT
            : PatientConsentNotificationType.PDDE_DECLINE_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REVOKE_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT
            : isAiDataUse
                ? PatientConsentNotificationType.AI_DATA_USE_REVOKE_ENROLLMENT
                : PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT;
    }
    else {
        return notificationType;
    }
}
export var PatientStudyNotificationType;
(function (PatientStudyNotificationType) {
    PatientStudyNotificationType["WITHDRAWN"] = "WITHDRAWN";
    PatientStudyNotificationType["REMOVED_ENROLLED"] = "REMOVED_ENROLLED";
    PatientStudyNotificationType["RE_ADDED"] = "RE_ADDED";
    PatientStudyNotificationType["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    PatientStudyNotificationType["PDDE_RESEARCH_DATA_REMINDER"] = "PDDE_RESEARCH_DATA_REMINDER";
    PatientStudyNotificationType["PDDE_GENERAL_DATA_USE_DATA_REMINDER"] = "PDDE_GENERAL_DATA_USE_DATA_REMINDER";
    PatientStudyNotificationType["PDDE_RESEARCH_UPDATE_RECORDS"] = "PDDE_RESEARCH_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS"] = "PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_RESEARCH_RECORDS_UPDATED"] = "PDDE_RESEARCH_RECORDS_UPDATED";
    PatientStudyNotificationType["AI_DATA_USE_DATA_REMINDER"] = "AI_DATA_USE_DATA_REMINDER";
})(PatientStudyNotificationType || (PatientStudyNotificationType = {}));
export const externalResearcherSupportedPatientStudyNotificationTypes = new Set([
    PatientStudyNotificationType.WITHDRAWN,
    PatientStudyNotificationType.REMOVED_ENROLLED,
    PatientStudyNotificationType.RE_ADDED,
    PatientStudyNotificationType.PDDE_RESEARCH_DATA_REMINDER,
    PatientStudyNotificationType.PDDE_GENERAL_DATA_USE_DATA_REMINDER,
    PatientStudyNotificationType.PDDE_RESEARCH_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_RESEARCH_RECORDS_UPDATED,
]);
export var PatientRecordRetrievalNotificationType;
(function (PatientRecordRetrievalNotificationType) {
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_UPDATE"] = "PDDE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_INITIAL"] = "PDDE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["PDDE_NO_RECORDS"] = "PDDE_NO_RECORDS";
    PatientRecordRetrievalNotificationType["IAS_RECORDS_FOUND"] = "IAS_RECORDS_FOUND";
    PatientRecordRetrievalNotificationType["IAS_NO_RECORDS"] = "IAS_NO_RECORDS";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_INITIAL"] = "AI_DATA_USE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_UPDATE"] = "AI_DATA_USE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_NO_RECORDS"] = "AI_DATA_USE_NO_RECORDS";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_VECTORIZATION_FAILED"] = "AI_DATA_USE_VECTORIZATION_FAILED";
})(PatientRecordRetrievalNotificationType || (PatientRecordRetrievalNotificationType = {}));
export var PatientGeneralNotificationType;
(function (PatientGeneralNotificationType) {
    PatientGeneralNotificationType["ACCOUNT_DELETION_CONFIRMATION"] = "ACCOUNT_DELETION_CONFIRMATION";
})(PatientGeneralNotificationType || (PatientGeneralNotificationType = {}));
export class PatientBaseNotificationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], PatientBaseNotificationInput.prototype, "patientIds", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientBaseNotificationInput.prototype, "organizationLogoUrl", void 0);
__decorate([
    IsOptional(),
    Type(() => NotificationAttachment),
    __metadata("design:type", Array)
], PatientBaseNotificationInput.prototype, "attachments", void 0);
__decorate([
    IsEnum(ContactMethod),
    IsOptional(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "patientContactMethod", void 0);
__decorate([
    IsEnum(StudyTranslationLanguage),
    IsOptional(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "patientLanguage", void 0);
__decorate([
    IsOptional(),
    Type(() => PatientLanguageSwitchUrls),
    __metadata("design:type", PatientLanguageSwitchUrls)
], PatientBaseNotificationInput.prototype, "patientLanguageSwitchUrls", void 0);
export class PatientBaseNotificationWithOptionalOrganizationInput extends OmitType(PatientBaseNotificationInput, [
    "organizationId",
    "organizationName",
    "organizationLogoUrl",
]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationLogoUrl", void 0);
export class PatientNotificationInput extends PatientBaseNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientNotificationInput.prototype, "studyId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientNotificationInput.prototype, "aiAgentName", void 0);
export class PatientConsentNotificationInput extends OmitType(PatientNotificationInput, ["patientIds"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientConsentNotificationType),
    __metadata("design:type", String)
], PatientConsentNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    IsObject({ each: true }),
    __metadata("design:type", Array)
], PatientConsentNotificationInput.prototype, "patientIds", void 0);
export class PatientStudyNotificationInput extends PatientNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientStudyNotificationType),
    __metadata("design:type", String)
], PatientStudyNotificationInput.prototype, "patientNotificationType", void 0);
export class PatientRecordRetrievalNotificationInput extends OmitType(PatientNotificationInput, ["studyId"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientRecordRetrievalNotificationInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(PatientRecordRetrievalNotificationType),
    __metadata("design:type", String)
], PatientRecordRetrievalNotificationInput.prototype, "patientNotificationType", void 0);
export class PatientGeneralNotificationInput extends PatientBaseNotificationWithOptionalOrganizationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientGeneralNotificationType),
    __metadata("design:type", String)
], PatientGeneralNotificationInput.prototype, "patientNotificationType", void 0);
export class RelatedPersonDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], RelatedPersonDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], RelatedPersonDto.prototype, "lastName", void 0);
export class ProxyAccessDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProxyAccessDto.prototype, "isEnabled", void 0);
__decorate([
    Type(() => RelatedPersonDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], ProxyAccessDto.prototype, "relatedPerson", void 0);
export class PatientMappingDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientMappingDto.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "dateOfBirth", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientMappingDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientMappingDto.prototype, "updatedAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], PatientMappingDto.prototype, "isSandbox", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], PatientMappingDto.prototype, "phoneVerified", void 0);
export var PatientAccountDeletionRequestReasonType;
(function (PatientAccountDeletionRequestReasonType) {
    PatientAccountDeletionRequestReasonType["NO_LONGER_USE"] = "NO_LONGER_USE";
    PatientAccountDeletionRequestReasonType["PRIVACY_CONCERNS"] = "PRIVACY_CONCERNS";
    PatientAccountDeletionRequestReasonType["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
    PatientAccountDeletionRequestReasonType["OTHER"] = "OTHER";
})(PatientAccountDeletionRequestReasonType || (PatientAccountDeletionRequestReasonType = {}));
export class PatientDeleteAccountInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientAccountDeletionRequestReasonType),
    __metadata("design:type", String)
], PatientDeleteAccountInput.prototype, "deletedReasonType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDeleteAccountInput.prototype, "deletedReasonMessage", void 0);
export class CreateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "First name of the test patient. Defaults to 'Test' if not provided.",
        example: "Test",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Last name of the test patient. Defaults to 'Patient' if not provided.",
        example: "Patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "dateOfBirth", void 0);
export class TestPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Unique identifier for the test patient",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "id", void 0);
__decorate([
    ApiProperty({
        description: "Auto-generated email address in format test-patient+[random]@[org-domain]",
        example: "test-patient+dqKVeMid8N41@example.com",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "email", void 0);
__decorate([
    ApiProperty({
        description: "First name of the test patient",
        example: "Test",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "firstName", void 0);
__decorate([
    ApiProperty({
        description: "Last name of the test patient",
        example: "Patient",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth in ISO format",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], TestPatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    ApiProperty({
        description: "ID of the organization this test patient belongs to",
        example: "658ac9e4-2a8b-4775-a58f-06ef6d65d914",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "organizationId", void 0);
__decorate([
    ApiProperty({
        description: "Timestamp when the test patient was created",
        example: "2026-01-31T01:52:05.653Z",
    }),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TestPatientDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({
        description: "Indicates this is a test patient",
        example: true,
    }),
    IsBoolean(),
    __metadata("design:type", Boolean)
], TestPatientDto.prototype, "isTestPatient", void 0);
export class TestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Auto-generated password. This is only returned once at creation time and cannot be retrieved later.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    IsString(),
    __metadata("design:type", String)
], TestPatientResponseDto.prototype, "password", void 0);
export class UpdateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "New first name for the test patient",
        example: "TestUpdated",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "New last name for the test patient",
        example: "PatientUpdated",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "New date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Set to true to generate a new random password",
        example: true,
    }),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateTestPatientInput.prototype, "regeneratePassword", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Set a specific password instead of generating one",
        example: "MyCustomPassword123!",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "password", void 0);
export class UpdateTestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "New password if regeneratePassword was true or password was provided. Not included if password was not changed.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientResponseDto.prototype, "password", void 0);
export var TestPatientConsentStatus;
(function (TestPatientConsentStatus) {
    TestPatientConsentStatus["OPTED_IN"] = "OPTED_IN";
    TestPatientConsentStatus["OPTED_OUT"] = "OPTED_OUT";
})(TestPatientConsentStatus || (TestPatientConsentStatus = {}));
export class UpdateTestPatientConsentInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Consent status - OPTED_IN to grant consent, OPTED_OUT to revoke consent",
        enum: TestPatientConsentStatus,
        enumName: "TestPatientConsentStatus",
        example: TestPatientConsentStatus.OPTED_IN,
    }),
    IsEnum(TestPatientConsentStatus),
    __metadata("design:type", String)
], UpdateTestPatientConsentInput.prototype, "consentStatus", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Reason for revocation (only applicable when consentStatus is OPTED_OUT)",
        example: "Testing revocation flow",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTestPatientConsentInput.prototype, "revocationReason", void 0);
export class UpdateTestPatientConsentResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "ID of the consent record that was created or updated",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    IsString(),
    __metadata("design:type", String)
], UpdateTestPatientConsentResponseDto.prototype, "consentRecordId", void 0);
export class UpdatePatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "phone", void 0);
